import { Checkbox, TextField, FormControlLabel } from "@material-ui/core";
import { CustomNumericFormat } from "../core/CustomNumericFormat";
import { useTranslation } from "react-i18next";
import type { ChangeEvent } from "react";

type ListingDialogInputFeeProps = {
  fee: number;
  name?: string;
  loading: boolean;
  required?: boolean;
  checkboxName?: string;
  feeIncludesTaxes: boolean;
  handleChange: ({ target: { name, value } }: ChangeEvent<HTMLInputElement>) => void;
  handleChangeChecked: ({ target: { name, checked } }: ChangeEvent<HTMLInputElement>) => void;
};

export function ListingDialogInputFee({
  fee,
  name,
  loading,
  required,
  checkboxName,
  feeIncludesTaxes,
  handleChange,
  handleChangeChecked
}: ListingDialogInputFeeProps): JSX.Element {
  const { t: translate } = useTranslation();

  return (
    <TextField
      fullWidth
      disabled={loading}
      label={translate(`listingsPage.tableColumns.${name ?? "fee"}`)}
      name={!name || name === "sellerFee" ? "fee" : name}
      value={fee ?? ""}
      required={required}
      onChange={handleChange}
      InputProps={{
        sx: { pr: 0 },
        inputComponent: CustomNumericFormat as never,
        endAdornment: (
          <FormControlLabel
            sx={{
              transition: "opacity 150ms",
              opacity: fee ? 1 : 0,
              pointerEvents: fee ? "auto" : "none",
              "& > span:last-child": { whiteSpace: "nowrap" }
            }}
            disabled={loading}
            control={
              <Checkbox
                sx={{ p: 0.5 }}
                size="small"
                name={checkboxName ?? "feeIncludesTaxes"}
                checked={feeIncludesTaxes}
                onChange={handleChangeChecked}
              />
            }
            label={translate(`listingsPage.tableColumns.feeIncludesTaxes`)}
          />
        )
      }}
    />
  );
}
